
import request from "@/utils/request";
import { Notification, Loading, Message } from "element-ui";

export function post(url, data, options = {}) {
  if (url.indexOf("/api/") >= 0) {
    url = url.replace(/^\/api/g, "");
  }

  return request({
    url,
    method: "post",
    data,
    ...options
  });
}

export function download(url, data, fileName) {
  if (url.indexOf("/api/") >= 0) {
    url = url.replace(/^\/api/g, "");
  }
  const loading = Loading.service({
    text: '正在下载...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  request({
    url: url,
    method: "post",
    data: data,
    timeout: 1200000,
    responseType: "blob"
  })
    .then(res => {
      loading.close();

      // 获取数据类型
      const type = res.data.type;

      // 后台返回JSON错误信息
      if (type === "application/json") {
        res.data.text().then(text => {
          const json = JSON.parse(text);
          // 其它错误
          Notification.error({
            title: "提示信息",
            message: json.msg
          });
        });
        return;
      }

      // 模拟下载行为
      let link = document.createElement("a");
      link.href = URL.createObjectURL(res.data);
      link.setAttribute("download", fileName);
      link.click();
      link = null;

      Notification.success({
        title: "提示信息",
        message: "数据导出成功！"
      });
    })
    .catch(err => {
      loading.close();
      reject(err);
    });
}
